import { useEffect, useState } from 'react';
import '../../App.css';
import './AgendamentoPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Navbar from '../../components/PublicUi/PublicNavbar/PublicNavbar';
import Grid from '../../components/PublicUi/PublicGrid/PublicGridAgendamento';
import PublicAgendamentoForm from '../../components/PublicForms/PublicAgendamentosForm';
import PublicUpdateAgendamentoForm from '../../components/PublicForms/PublicUpdateAgendamentoForm';
import PublicCancelamentoForm from '../../components/PublicForms/PublicCancelamentoForm';
import HorariosService from '../../services/HorariosService';
import AgendamentosService from '../../services/AgendamentosService'; 
import CancelamentosService from '../../services/CancelamentosService';
import { usePermissao } from '../../hooks/usePermissao';
import Agenda from '../../assets/icons/agenda.png';

export default function AgendamentoPage() {

  const { acessoPermissao } = usePermissao();
  const permissaoCriar = acessoPermissao("agendamentos", "cadastrar");
  const permissaoEditar = acessoPermissao("agendamentos", "atualizar");

  const hook = usePermissao();

  const [dataSelecionada, setDataSelecionada] = useState(
    new Date().toISOString().split('T')[0]
  );

  const [horarios, setHorarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const [retorno, setRetorno] = useState(null);

  const [formAberto, setFormAberto] = useState(false);
  const [modoFormulario, setModoFormulario] = useState(null);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);

  const actions = [];
  if (permissaoCriar) actions.push("Novo");
  if (permissaoEditar) actions.push("Alterar");
  if (permissaoCriar) actions.push("Cancelar");

  const handleSubmitAgendamento = async (payload) => {
    try {
      setLoading(true);
      setErro(null);
      setRetorno(null);

      await AgendamentosService.create(payload);

      setRetorno('Agendamento realizado com sucesso!');
      setFormAberto(false);
      buscarHorarios(dataSelecionada);

    } catch (error) {
      setFormAberto(false);
      setErro(error.response?.data?.message || 'Erro ao salvar agendamento');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitUpdateAgendamento = async ({ id, payload }) => {
    try {
      setLoading(true);

      await AgendamentosService.update(id, payload);

      setRetorno('Agendamento atualizado com sucesso!');
      setFormAberto(false);
      buscarHorarios(dataSelecionada);

    } catch (error) {
      setFormAberto(false);
      setErro(error.response?.data?.message || 'Erro ao atualizar agendamento');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitCancelamento = async ({ payload }) => {
    try {
      setLoading(true);

      await CancelamentosService.cancelarPublico(
        payload
      );

      setRetorno('Agendamento cancelado com sucesso!');
      setFormAberto(false);
      buscarHorarios(dataSelecionada);

    } catch (error) {
      setFormAberto(false);
      setErro(error.response?.data?.message || 'Erro ao cancelar agendamento');
    } finally {
      setLoading(false);
    }
  };


  const buscarHorarios = async (data) => {
    setLoading(true);
    setErro(null);

    try {

      const hoje = new Date().toISOString().split('T')[0];

      if (data < hoje) {
        setErro("Não é possível consultar datas retroativas.");
        setHorarios([]);
        return;
      }

      const resposta = await HorariosService.getDisponiveis(data);

      if (!resposta || resposta.length === 0) {
        setErro("Sem horários disponíveis para o dia.");
        setHorarios([]);
        return;
      }
      setHorarios(resposta);

    } catch (e) {
      setErro(
        e.response?.data?.erro ||
        e.response?.data?.message ||
        "Erro ao buscar horários."
      );
      setHorarios([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarHorarios(dataSelecionada);
  }, [dataSelecionada]);

  const handleNavbarAction = (acao) => {
    switch (acao) {

      case 'Novo':
        if (!permissaoCriar) return;
        setAgendamentoSelecionado(null);
        setModoFormulario('create');
        setFormAberto(true);
        break;

      case 'Alterar':
        if (!permissaoEditar) return;
        setModoFormulario('update');
        setFormAberto(true);
        break;

      case 'Cancelar':
        if (!permissaoCriar) return;
        setAgendamentoSelecionado(null);
        setModoFormulario('cancelar');
        setFormAberto(true);
        break;

      default:
        //console.log("Ação não reconhecida:", acao);
    }
  };

  const handleSelecionarHorario = (horario) => {
    setAgendamentoSelecionado(horario);
    setModoFormulario('create'); 
    setFormAberto(true);
  };

  const colunas = [
    { header: 'Data', field: 'data' },
    { header: 'Dia', field: 'diaSemana' },
    { header: 'Horário', field: 'horario' },
    {
      header: 'Descrição',
      field: 'disponivel',
      render: (row) =>
        row.disponivel ? "Horário Disponível" : "Fechado nessa data"
    }
  ];

  return (
    <div className="AgendamentoPage-container">
      <Header />

      <article>
        <div className="Agendamentos">
          <div className="Agendamento-header">
            <img src={Agenda} alt="Agendamento" />
            Agendamento
          </div>

          <div className="Agendamento-linha"></div>

          {formAberto && (
            <>
              {modoFormulario === 'create' && (
                <PublicAgendamentoForm
                  agendamento={agendamentoSelecionado}
                  onClose={() => {
                    setFormAberto(false);
                    setModoFormulario(null);
                  }}
                  onSubmit={handleSubmitAgendamento}
                />
              )}

              {modoFormulario === 'update' && (
                <PublicUpdateAgendamentoForm
                  onClose={() => {
                    setFormAberto(false);
                    setModoFormulario(null);
                  }}
                  onSubmit={handleSubmitUpdateAgendamento}
                />
              )}
              
              {modoFormulario === 'cancelar' && (
                <PublicCancelamentoForm
                  onClose={() => {
                    setFormAberto(false);
                    setModoFormulario(null);
                  }}
                  onSubmit={handleSubmitCancelamento}
                />
              )}
            </>
          )}

          {retorno && (
            <div className="mensagem-sucesso">
              {retorno}
            </div>
          )}

          {erro && (
            <div className="mensagem-erro">
              {erro}
            </div>
          )}

          <Navbar
            actions={actions}
            onActionClick={handleNavbarAction}
          />

          <div className="Agendamento-subtitulo">
            Consultar Disponibilidade:
            <div className="Agendamento-filtro">
              <input
                type="date"
                value={dataSelecionada}
                className="date"
                onChange={(e) => setDataSelecionada(e.target.value)}
                min={new Date().toISOString().split('T')[0]}
              />
            </div>
          </div>

          <div className="Agendamento-linha-subtitulo" />

          {loading && <p>Carregando horários...</p>}

          {!loading && horarios.length > 0 && (
            <Grid
              columns={colunas}
              data={horarios}
              onSelecionarHorario={handleSelecionarHorario}
            />
          )}

          {!loading && horarios.length === 0 && !erro && (
            <p>Nenhum horário disponível.</p>
          )}
        </div>
      </article>

      <Footer />
    </div>
  );
}
